
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/international-shipping-services",
      function () {
        return require("private-next-pages/international-shipping-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/international-shipping-services"])
      });
    }
  